export default "__VITE_ASSET__DY4eak3I__"